import { useLanguage } from '../../lib/i18n/LanguageContext';
import { generateAltText } from '../../lib/utils/imageOptimization';
import SectionTitle from '../../components/ui/SectionTitle';

const AboutHistory = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 bg-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <SectionTitle title={t.about.history.title} align="left" className="mb-8" />
            <div className="space-y-6 text-neutral-700">
              {t.about.history.content.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </div>
          <div className="relative">
            <img
              src="/images/rossof5.jpg"
              alt={generateAltText('exterior', 'Historic restaurant location on Laugavegur')}
              title="Rossopomodoro Reykjavik - Historic location on Laugavegur since 2006"
              loading="lazy"
              width="800"
              height="600"
              className="rounded-lg shadow-lg h-80 w-full object-cover"
            />

            <div className="absolute -bottom-6 -left-6 bg-red-800 text-white p-6 rounded shadow-lg hidden md:flex items-center justify-center">
              <p className="font-serif text-xl font-bold">{t.about.history.since}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHistory;
